import { render, staticRenderFns } from "./CRTextField.vue?vue&type=template&id=df27578a&scoped=true"
import script from "./CRTextField.vue?vue&type=script&lang=js"
export * from "./CRTextField.vue?vue&type=script&lang=js"
import style0 from "./CRTextField.vue?vue&type=style&index=0&id=df27578a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df27578a",
  null
  
)

export default component.exports